import { __decorate, __metadata } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { timerStyle } from './timer.style';
const millisecondsInDay = 86400000; // 24 * 60 * 60 * 1000
const millisecondsInHour = 3600000; // 60 * 60 * 1000
const millisecondsInMinute = 60000; // 60 * 1000
const millisecondsInSecond = 1000;
let TimerElement = class TimerElement extends LitElement {
    constructor() {
        super(...arguments);
        this.expirationTime = Date.now();
    }
    static { this.tagName = 'inch-timer'; }
    static { this.styles = timerStyle; }
    connectedCallback() {
        super.connectedCallback();
        this.viewUpdater();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.timer && void clearTimeout(this.timer);
    }
    render() {
        return html ` <span>${this.calculateTimeView()}</span> `;
    }
    viewUpdater() {
        this.requestUpdate();
        this.timer = setTimeout(() => this.viewUpdater(), 500);
    }
    calculateTimeView() {
        const currentTime = Date.now();
        const differenceInMilliseconds = this.expirationTime - currentTime;
        if (differenceInMilliseconds <= 0) {
            return `00:00`;
        }
        if (differenceInMilliseconds < millisecondsInDay) {
            // Less than a day
            const hours = Math.floor(differenceInMilliseconds / millisecondsInHour);
            const minutes = Math.floor((differenceInMilliseconds % millisecondsInHour) / millisecondsInMinute);
            const seconds = Math.floor((differenceInMilliseconds % millisecondsInMinute) / millisecondsInSecond);
            if (hours === 0) {
                return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
            else {
                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
        }
        else {
            // More than a day
            const days = Math.floor(differenceInMilliseconds / millisecondsInDay);
            const hours = Math.floor((differenceInMilliseconds % millisecondsInDay) / millisecondsInHour);
            return `${days}D ${hours}h`;
        }
    }
};
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], TimerElement.prototype, "expirationTime", void 0);
TimerElement = __decorate([
    customElement(TimerElement.tagName)
], TimerElement);
export { TimerElement };
//# sourceMappingURL=timer.element.js.map